import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ErrorBoundary } from "react-error-boundary";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { store, persistor } from "./store";
import AppRoutes from "./routes";
import NewVersionBanner from "./components/atoms/new-version-banner/NewVersionBanner";
import ErrorFallback from "./pages/error/error";
import "./App.scss";

function App() {
	return (
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<ErrorBoundary FallbackComponent={ErrorFallback}>
					<NewVersionBanner />
					<AppRoutes />
					<ToastContainer />
				</ErrorBoundary>
			</PersistGate>
		</Provider>
	);
}

export default App;
